<template>
  <modal name="prime-complete-popup" :adaptive="true" :scrollable="true" height="auto" :clickToClose="true"
    :escToClose="true" @before-close="handleBeforeClose" @closed="handleClosed" class="prime-complete-popup-modal">
    <div class="v--modal-close-top">
      <el-button @click="closePopup" icon="el-icon-circle-close" style="font-size: 2rem; padding: 0;"
        type="text"></el-button>
    </div>

    <div class="prime-complete-popup">
      <h2 class="pc-h2">ヤギプライムへようこそ🎉<br>ご登録ありがとうございます！</h2>
      <img src="/static/img/08.png" alt="ヤギプライムへようこそ🎉ご登録ありがとうございます！" class="pc-img">
      <p class="pc-txt">ヤギプライムへのお支払いが完了しました。<br>AI文章作成や証明写真風加工、AI面接練習など履歴書作成から転職活動までもっと便利になる機能がたくさん！</p>

      <div class="pc-btn">
        <button v-if="hasResumeData" class="pc-step1-btn pc-diagnosis-btn" @click="goToDiagnosis"><span>あなたの隠れスキルを発見</span><br>隠れスキル診断を受ける</button>
        <a v-else href="/format/rirekisho_job_change" class="pc-step1-btn pc-diagnosis-btn"><span>履歴書を作ると診断できる！</span><br>まずは履歴書を作る</a>
        <button class="pc-back-btn" @click="closePopup">戻って便利な機能をつかう</button>
        <!-- <button class="pc-step1-btn" @click="goToAgent"><span>希望条件を設定して</span><br>エージェントとつながる</button> -->
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  name: 'PrimeCompletePopup',
  data () {
    return {
      closeCallback: null,
      hasResumeData: false
    }
  },
  methods: {
    /**
     * ポップアップを表示する
     * @param {Function} callback - ポップアップが閉じられた時に実行するコールバック関数
     */
    showPopup (callback = null) {
      this.closeCallback = callback

      // 背景の志望動機文章作成ポップアップを非表示にする
      this.$modal.hide('ai-mypr-dialog')

      this.$modal.show('prime-complete-popup')
    },

    /**
     * ポップアップを閉じる
     */
    closePopup () {
      this.$modal.hide('prime-complete-popup')
    },

    /**
     * エージェントページに遷移
     */
    goToAgent () {
      this.closePopup()
      // エージェントページを別タブで開く
      window.open('/mypage/yagiprime', '_blank')
    },

    goToDiagnosis () {
      // リロード用コールバックをクリアしてから閉じる
      this.closeCallback = null
      this.closePopup()
      this.$eventHub.$emit('show-skill-diagnosis-popup')
    },

    /**
     * モーダルが閉じられる前の処理
     * @param {Object} event - モーダルイベント
     */
    handleBeforeClose (event) {
      // 必要に応じて閉じる前の処理を追加
      console.log('[PrimeCompletePopup] モーダルが閉じられます')
    },

    /**
     * モーダルが閉じられた後の処理
     */
    handleClosed () {
      console.log('[PrimeCompletePopup] モーダルが閉じられました')

      // コールバック関数が設定されている場合は実行
      if (typeof this.closeCallback === 'function') {
        console.log('[PrimeCompletePopup] コールバック関数を実行します')
        try {
          this.closeCallback()
        } catch (error) {
          console.error('[PrimeCompletePopup] コールバック実行エラー:', error)
        }
      }

      // コールバックをリセット
      this.closeCallback = null
    }
  },

  created () {
    // 履歴書データの有無を確認
    const app = this
    this.$iterateStorage(function (value, key) {
      if (key === 'basicData') {
        app.hasResumeData = true
      }
    })

    // イベントリスナーを登録
    this.$eventHub.$on('show-prime-complete-popup', this.showPopup)
  },

  beforeDestroy () {
    // イベントリスナーを解除
    this.$eventHub.$off('show-prime-complete-popup', this.showPopup)
  }
}
</script>

<style lang="scss" scoped>
.prime-complete-popup {
  text-align: center;
  padding: 10px;
  box-sizing: border-box;

  .pc-h2 {
    line-height: 1.4;
    font-size: 18px;
    margin-bottom: 15px;

    // スマホ対応
    @media (max-width: 480px) {
      font-size: 16px;
      margin-bottom: 12px;
    }
  }

  .pc-img {
    margin: 10px 0;
    width: 100%;
    max-width: 250px;
    height: auto;

    // スマホ対応
    @media (max-width: 480px) {
      max-width: 280px;
      margin: 8px 0;
    }
  }

  .pc-txt {
    text-align: left;
    margin-bottom: 20px;
    font-size: 14px;
    line-height: 1.6;
    word-wrap: break-word;

    // スマホ対応
    @media (max-width: 480px) {
      font-size: 13px;
      margin-bottom: 15px;
    }
  }

  .pc-btn {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;

    button {
      height: 60px;
    }

    .pc-back-btn {
      width: 100%;
      max-width: 300px;
      padding: 14px 10px;
      font-weight: bold;
      color: #E3165C;
      background: #ffffff;
      border-radius: 10px;
      border: 1px solid #E3165C;
      cursor: pointer;
      font-size: 14px;
      box-sizing: border-box;

      // スマホ対応
      @media (max-width: 480px) {
        max-width: 280px;
        padding: 12px 8px;
        font-size: 13px;
        margin-bottom: 12px;
      }
    }

    .pc-step1-btn {
      width: 100%;
      max-width: 300px;
      padding: 14px 10px;
      margin-bottom: 10px;
      font-weight: bold;
      color: #ffffff;
      background: #E3165C;
      border-radius: 10px;
      border: 1px solid #E3165C;
      cursor: pointer;
      font-size: 14px;
      box-sizing: border-box;

      span {
        font-size: 12px;

        // スマホ対応
        @media (max-width: 480px) {
          font-size: 11px;
        }
      }

      // スマホ対応
      @media (max-width: 480px) {
        max-width: 280px;
        padding: 12px 8px;
        font-size: 13px;
      }
    }
  }
}
</style>

<style lang="scss">
.prime-complete-popup-modal {
  .v--modal {
    margin: 20px;
    border-radius: 8px;
    padding: 20px;
    max-width: 500px !important;
    box-sizing: border-box;
    top: 50px !important;

    // スマホ対応 - 位置を上に調整
    @media (max-width: 480px) {
      margin: 10px;
      padding: 15px;
      max-width: calc(100vw - 20px);
      width: calc(100vw - 20px) !important;
      border-radius: 6px;
      position: relative;
    }

    // 非常に小さい画面対応
    @media (max-width: 360px) {
      margin: 5px;
      padding: 10px;
      max-width: calc(100vw - 10px);
      width: calc(100vw - 10px) !important;
    }
  }
}
</style>
